import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { StoreEmployeeRequirement } from '../../../classes/models/store/StoreEmployeeRequirement';
import {
  AddStoreEmployeeRequirementRequest,
  EditStoreEmployeeRequirementRequest
} from '../../../interfaces/request/StoreRequests';

/**
 * This service communicates with backend to handle store employee requirements data management.
 */
@Injectable({
  providedIn: 'root'
})
export class StoreEmployeeRequirementService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/stores';

  /**
   * Adds a new requirement for a specific store.
   * @param storeId an identifier of a store.
   * @param requirement a requirement to be added.
   */
  addRequirement(storeId: string, requirement: StoreEmployeeRequirement) {
    const url = `${this.url}/${storeId}/employee-requirements`;
    const requestBody: AddStoreEmployeeRequirementRequest = {
      date: requirement.startDate,
      minimumOpeningEmployees: requirement.minimumOpeningEmployees,
      minimumRegularEmployees: requirement.minimumRegularEmployees,
      minimumClosingEmployees: requirement.minimumClosingEmployees,
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits a requirement for a specific store.
   * @param storeId an identifier of a store.
   * @param requirement a requirement to be edited.
   */
  editRequirement(storeId: string, requirement: StoreEmployeeRequirement) {
    const url = `${this.url}/${storeId}/employee-requirements/${requirement.startDate}`;
    const requestBody: EditStoreEmployeeRequirementRequest = {
      minimumOpeningEmployees: requirement.minimumOpeningEmployees,
      minimumRegularEmployees: requirement.minimumRegularEmployees,
      minimumClosingEmployees: requirement.minimumClosingEmployees,
    };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes a requirement for the given store starting from the given date.
   * @param storeId an identifier of a store.
   * @param date start date of a requirement.
   */
  deleteRequirement(storeId: string, date: string) {
    const url = `${this.url}/${storeId}/employee-requirements/${date}`;
    return this.http.delete(url);
  }
}
